import React from "react";
import { iso2Of } from "@/lib/countryFlagIso2";

/**
 * Cross-platform country flag using the `flag-icons` CSS sprite.
 * Real SVG artwork — never OS emoji. Consistent render on Windows,
 * Mac, iOS, and Android.
 *
 * Sizes are set via className. `variant="rect"` (default) uses the
 * flag's natural 4:3 rectangle; `variant="square"` shows the 1:1
 * cropped version bundled with flag-icons.
 */
export function CountryFlag({ cc, className = "", variant = "rect", title }) {
  const iso = iso2Of(cc);
  if (!iso) {
    // Last-resort visual fallback: the FIFA code inside a small monogram.
    return (
      <span
        className={`inline-flex items-center justify-center font-mono text-[10px] tracking-widest bg-white/10 border border-white/20 text-white/80 rounded-sm ${className}`}
        aria-label={cc}
        title={title || cc}
      >
        {(cc || "").slice(0, 3)}
      </span>
    );
  }
  const cls = variant === "square" ? "fis" : "fi";
  return (
    <span
      className={`fi fi-${iso} ${cls} ${className}`}
      aria-label={title || cc}
      title={title || cc}
    />
  );
}
